import React, { useMemo } from "react";
import {
  DEFAULT_DUE_DATE_PRESET_DAYS,
  getDueDateFromDays,
  resolveDueDatePresetValue,
} from "../utils/datePresets";

const DatePresetPicker = ({
  label = "Fecha",
  presetLabel = "Plazo",
  inputLabel = "Fecha personalizada",
  presetOptionLabel = (days) => `${days} dias`,
  value,
  onChange,
  presetDays = DEFAULT_DUE_DATE_PRESET_DAYS,
  containerClassName = "",
  selectClassName = "border border-gray-300 rounded p-2 w-full",
  inputClassName = "border border-gray-300 rounded p-2 w-full",
  labelClassName = "block text-sm font-medium mb-1",
  inputLabelClassName = "block text-xs text-gray-600 mb-1",
}) => {
  const presetValue = useMemo(
    () => resolveDueDatePresetValue(value, presetDays),
    [value, presetDays]
  );

  const handlePresetChange = (nextValue) => {
    if (nextValue === "custom") return;
    const nextDate = getDueDateFromDays(nextValue);
    onChange?.(nextDate);
  };

  return (
    <div className={containerClassName}>
      <label className={labelClassName}>{label}</label>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        <div>
          <label className={inputLabelClassName}>{presetLabel}</label>
          <select
            className={selectClassName}
            value={presetValue}
            onChange={(event) => handlePresetChange(event.target.value)}
          >
            {presetDays.map((days) => (
              <option key={days} value={String(days)}>
                {presetOptionLabel(days)}
              </option>
            ))}
            <option value="custom">Personalizado</option>
          </select>
        </div>
        <div>
          <label className={inputLabelClassName}>{inputLabel}</label>
          <input
            type="date"
            className={inputClassName}
            value={value || ""}
            onChange={(event) => onChange?.(event.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default DatePresetPicker;
